import React, { useCallback } from "react";
import { PhotoIcon } from "@heroicons/react/24/outline";
import { convertSelectionToImageTag } from "../utility/utility";

const FormattingToolbar = ({ textareaRef, value, onChange }) => {

  
  // Helper to wrap selected text
  const wrapSelection = useCallback(
    (open, close) => {
      const el = textareaRef?.current;
      const current = value;

      if (!el) {
        onChange(`${current}${open}${close}`);
        return;
      }

      const start = el.selectionStart ?? current.length;
      const end = el.selectionEnd ?? start;

      const before = current.slice(0, start);
      const selected = current.slice(start, end);
      const after = current.slice(end);

      const newValue = `${before}${open}${selected}${close}${after}`;
      const caretPos = (before + open + selected + close).length;

      // Update textarea directly first
      el.value = newValue;
      el.focus();
      el.setSelectionRange(caretPos, caretPos);

      // Then update state
      onChange(newValue);
    },
    [textareaRef, value, onChange]
  );

  const handleBold = () => wrapSelection("<b>", "</b>");
  const handleItalic = () => wrapSelection("<i>", "</i>");
  const handleUnderline = () => wrapSelection("<u>", "</u>");

  const handleInsertImage = () => {
    const el = textareaRef.current;
    const current = value;

    const start = el?.selectionStart ?? current.length;
    const end = el?.selectionEnd ?? start;

    convertSelectionToImageTag(
      current,
      start,
      end,
      (updated) => onChange(updated),
      textareaRef
    );
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <button
        type="button"
        title="Bold"
        onClick={handleBold}
        className="px-2 py-1 text-sm font-semibold rounded border border-gray-300 hover:bg-gray-100"
      >
        <span className="font-bold">B</span>
      </button>

      <button
        type="button"
        title="Italic"
        onClick={handleItalic}
        className="px-2 py-1 text-sm italic rounded border border-gray-300 hover:bg-gray-100"
      >
        I
      </button>

      <button
        type="button"
        title="Underline"
        onClick={handleUnderline}
        className="px-2 py-1 text-sm underline rounded border border-gray-300 hover:bg-gray-100"
      >
        U
      </button>

      <button
        type="button"
        title="Insert image"
        onClick={handleInsertImage}
        className="px-2 py-1 text-sm rounded border border-gray-300 hover:bg-gray-100 flex items-center gap-1"
      >
        <PhotoIcon className="w-4 h-4" />
        Image
      </button>
    </div>
  );
};

export default FormattingToolbar;
